import { actions as CommonActions } from "@tailormed/common-client/store/action";

export const trackPendoEvent = (dispatch, eventName, eventData) => {
  const { sendPendoEvent } = CommonActions;
  dispatch(sendPendoEvent(eventName, eventData));
};

export default { trackPendoEvent };
